import { http } from '@shared/api';
import type { SessionUser } from '../model/types';

export const sessionApi = {
  me: () => http.get('me').json<SessionUser>(),
};
